<template>
    <PublicProfileLayout>
       
        <!-- Tutors Section -->
        <whyIlearndSection />

        <!-- Benefits Section -->
        <BenefitsSection />

        <!-- Teaching Made Easy Section -->
        <TeachingFeatureSection />

        <!-- Join as an Institute Section -->
        <CommunitySection title="Ready to Start Teaching?"
            description="Join hundreds of qualified tutors who are already earning a living by sharing their knowledge."
            label="Apply as a Tutor" :imageUrl="teachingImageUrl" />

        <!-- features  -->
        <FeatureSection />

        <!-- Students Testimonials Section -->
        <TestimonialSection :testimonials="testimonials" title="Success Stories of our tutors" badgeTitle="Testimonials"/>

        <!-- Join as an Institute Section -->
        <CommunitySection title="Join as an institute"
            description="Join hundreds of qualified tutors who are already earning a living by sharing their knowledge."
            label="Apply as an Institute" :imageUrl="IntituteImageUrl" />

        <!-- Contact Form Section -->
        <ContactFormSection :image="contactImage" />

    </PublicProfileLayout>
</template>

<script setup>
import { ref } from 'vue';
import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
import whyIlearndSection from "@/components/landingPage/becomeTutorPage/whyIlearndSection.vue"
import BenefitsSection from "@/components/landingPage/becomeTutorPage/benefitsSection.vue"
import CommunitySection from "@/components/landingPage/commonSections/communitySection.vue"
import TeachingFeatureSection from "@/components/landingPage/becomeTutorPage/teachingFeatureSection.vue"
import FeatureSection from "@/components/landingPage/becomeTutorPage/featureSection.vue"
import TestimonialSection from "@/components/landingPage/commonSections/testimonialSection.vue"
import ContactFormSection from "@/components/landingPage/commonSections/contactFormSection.vue"
import contactImage from "@/assets/Images/coconut-trees-right.png";

const teachingImageUrl = "public/ready-teaching.jpg"
const IntituteImageUrl = "public/institute.jpg"

const testimonials = ref([
    {
        name: "Kasun Rajapaksa",
        role: "A/L Student",
        location: "ICT, Kandy",
        avatar: "",
        testimonial: "The ICT tutor helped me with both theoretical concepts and practical programming. The one-on-one attention really made a difference. I'm now confident about my A/L ICT exam."
    },
    {
        name: "Sachini Perera",
        role: "O/L Student",
        location: "Mathematics, Colombo",
        avatar: "",
        testimonial: "My math tutor was amazing! They broke down complex problems into simple steps and helped me improve from a C to an A grade in just 3 months."
    },
    {
        name: "Dilshan Fernando",
        role: "University Student",
        location: "English Literature, Galle",
        avatar: "",
        testimonial: "The English literature sessions were incredibly insightful. My tutor's analysis techniques helped me excel in my university exams and develop a genuine love for literature."
    }
]);


</script>

<style scoped>
/* Hero Section */
.hero-section {
    position: relative;
    height: 500px;
    overflow: hidden;
    border-radius: 1rem;
}

.hero-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(70%);
}

.overlay-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 800px;
}


/* Responsive Styles */
@media (max-width: 767px) {
    .hero-section {
        height: 350px;
    }

    .overlay-content h1 {
        font-size: 1.5rem;
    }

    .overlay-content p {
        font-size: 0.9rem;
    }

    .why-section {
        padding: 2rem 1rem;
    }
}
</style>
